module.exports = __webpack_public_path__ + "static/media/AgencyClientIconFilter.1780a5dd.svg";